import toast from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL, apiService } from '../../services/service';
import { WALLET, WALLET_SUCCESS, WALLET_FAIL } from '../actionTypes';

export const fetchWallet = () => async (dispatch) => {
    try {
        dispatch({ type: WALLET });
        const response = await apiService.get(`${BASE_URL}${ApiEndpoints.GET_WALLET}`);
        dispatch({ type: WALLET_SUCCESS, payload: response.data });
        toast.success('Successful', { position: 'top-right' });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: WALLET_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
    }
};

export const wallet_payout_manual = (data) => async (dispatch) => {
    try {
        dispatch({ type: WALLET });

        const payoutData = {
            amount: data.amount,
            bank_account_id: data.bank_account_id,
            bank_code: data.bank_code,
            account_number: data.account_number,
            account_name: data.account_name,
            currency: data.currency,
        };

        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.WALLET_PAYOUT}`,
            payload: payoutData,
        });

        dispatch({ type: WALLET_SUCCESS, payload: response.data });
        toast.success('Manual withdrawal request submitted successfully!', {
            position: 'top-right',
        });

        return { success: true, data: response.data };
    } catch (error) {
        const message = error.message ? error.message : 'Network Error, please try again later.';
        dispatch({ type: WALLET_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
        return Promise.reject({ success: false, message });
    }
};

export const generate_withdrawal_otp = (email, phone) => async (dispatch) => {
    try {
        const response = await apiService.post({
            url: `${BASE_URL}/users/withdraw`,
            payload: { email, phone },
        });

        toast.success('OTP sent successfully!', { position: 'top-right' });
        return { success: true, data: response.data };
    } catch (error) {
        const message = error.message ? error.message : 'Failed to send OTP';
        toast.error(message, { position: 'top-right' });
        return Promise.reject({ success: false, message });
    }
};

export const wallet_payout_embedly = (data, otp, requestId) => async (dispatch) => {
    try {
        dispatch({ type: WALLET });

        const payoutData = {
            otp: otp,
            request_id: requestId,
            email: data.email,
            phone: data.phone,
            customer_type: 'Individual',
            amount: data.amount,
            bank_account_id: data.bank_account_id,
            bank_code: data.bank_code,
            bank_name: data.bank_name,
            account_number: data.account_number,
            account_name: data.account_name,
            currency: data.currency,
            first_name: data.first_name,
            last_name: data.last_name,
            middle_name: data.middle_name,
            date_of_birth: data.date_of_birth,
            gender: data.gender,
            address: data.address,
            city: data.city,
            state: data.state,
            country: data.country,
            nin: data.nin,
            bvn: data.bvn,
            proof_of_address: data.proof_of_address,
        };

        const response = await apiService.post({
            url: `${BASE_URL}/verify/otp/withdraw`,
            payload: payoutData,
        });

        dispatch({ type: WALLET_SUCCESS, payload: response.data });
        toast.success('Withdrawal request submitted successfully!', { position: 'top-right' });

        return { success: true, data: response.data };
    } catch (error) {
        const message = error.message ? error.message : 'Network Error, please try again later.';
        dispatch({ type: WALLET_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
        return Promise.reject({ success: false, message });
    }
};

// Legacy function for backward compatibility (defaults to embedly)
export const wallet_payout = (data) => wallet_payout_embedly(data);
